import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

import { DetailsLayout } from '../../components/detailsLayout/DetailsLayout'
import { useLayoutContext } from '../../context/layoutContext'
import { useParameterContext } from '../../context/parameterContext'
import { ParameterDetailsContentSelector } from '../parameter/parameterDetails/ParameterDetailsContentSelector'
import { ParameterDetailsTitle } from '../parameter/parameterDetails/ParameterDetailsTitle'

type Props = {
  onClose: () => void
}

export const ParameterDetailsRightSideBar = ({ onClose }: Props) => {
  const translate = useTranslate()
  const { viewingDetails, detailsPath } = useParameterContext()
  const {
    preferences: {
      common: { isUsingModal },
    },
  } = useLayoutContext()

  return (
    <div className="relative flex flex-col size-full overflow-hidden">
      <IconButton
        className="absolute! right-2 top-2"
        onClick={onClose}
        iconSize="md"
        tip={translate('close')}
        iconName="XCircle"
      />
      {viewingDetails && !isUsingModal ? (
        <>
          <div className="flex flex-row items-center justify-between whitespace-break-spaces break-all p-2 text-xl">
            <ParameterDetailsTitle data={viewingDetails} />
          </div>
          <DetailsLayout>
            <ParameterDetailsContentSelector
              data={viewingDetails}
              // Some components of the details panel like the markdown editors are stateful so its important to unmount them
              // when the detail path changes.
              key={detailsPath}
            />
          </DetailsLayout>
        </>
      ) : null}
    </div>
  )
}
